<template>
  <div
    id="introduction"
    class="pc-assembly top-nav"
    v-if="extras.introduction.display == 1"
  >
    <div class="max">
      <Title
        v-if="extras.introductionTitle.display == 1"
        :title="extras.introductionTitle.model || title"
        :isShowLine="false"
      />
      <div class="m-nodata-body" v-if="seminarInfo.desc.length == 0">
        <img src="@/assets/images/nodata.png" />
        <div class="m-nodata">暂无数据</div>
      </div>
      <div class="text" v-html="seminarInfo.desc"></div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/index/Title.vue";
export default {
  name: "Header",
  props: {
    seminarInfo: Object,
    extras: Object,
  },
  components: {
    Title,
  },
  data() {
    return {
      title: "大会介绍",
      text: ``,
    };
  },
  mounted() {},
};
</script>

<style scoped></style>
